import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { viewLoadingBlockVisible } = formStoreLenses

export default (state, { moduleId }) => viewLoadingBlockVisible(moduleId, state)
